import { useGlobalState } from "../contexts/GlobalStateContext";

export function ApproveButton({ post, blurValue, escalated }) {
  const { removePostWithFade, resetGlobalState, logOut } = useGlobalState();


  const baseUrl = process.env.REACT_APP_BASE_URL;
  const url = escalated ? `${baseUrl}/php/approve_escalated_post.php` : `${baseUrl}/php/approve_post.php`;
  // Handle the click for like/unlike
  const approvePost = () => {

    const payload = { uuid: post.uuid, currentBlur: blurValue};

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
            removePostWithFade(post.uuid);
        } else if (data.status === "error") {
          logOut();
          resetGlobalState();
        } else {
          console.error("Failed to approve post:", data.message);
        }
      })
      .catch((error) => {
        console.error("Error during approval:", error);
      });
  };

  return (
    <div className="bottom-left" id={post.uuid} onClick={approvePost}>
      Approve
    </div>
  );
}
